module.exports = __webpack_public_path__ + "img/coin_left.e1aff0c9.png";